/* eslint-disable no-unused-expressions */
import {Power0} from 'gsap';

// let scheme = null;
let svgScheme = '.chapter-position .chapter-fixed__figure.scheme-6 svg';
let scheme = document.querySelector(svgScheme);
let fullAnimation = null;

const play = () => {
	if (fullAnimation && fullAnimation.paused()) {
		fullAnimation.play();
	}
};

const pause = () => {
	if (fullAnimation && !fullAnimation.paused()) {
		fullAnimation.pause();
	}
};

const getFill = (el) => {
	return el.dataset.fill;
};

const showElement = (element, time = 0.45, delay = 0) => {
	const tm = gsap.timeline();
	fullAnimation.add(tm.play(), delay);

	tm
		.to(element, {
			ease: Power0.easeInOut,
			autoAlpha: 1,
			stagger: time / 3,
			duration: time,
		});
};

const setStrokeDashoffset = (el) => {
	const path = el.getTotalLength();
	gsap.set(el, {
		strokeDashoffset: path,
		strokeDasharray: `${path}, ${path}`,
	});
};

const hideElement = (el) => {
	gsap.timeline().set(el, {
		autoAlpha: 0,
	}, 0);
};

const reset = () => {
	const tm = gsap.timeline();
	scheme = document.querySelector('.chapter-fixed__figure.scheme-6 svg');
	const vibrationSensor = scheme.querySelectorAll('.vibration-sensor');
	const lineDottedMask = scheme.querySelector('.line-dotted-mask');
	const highlightGropup = scheme.querySelectorAll('.highlight-group');
	const lines = scheme.querySelectorAll('.lines-group .lines');

	const persone = scheme.querySelector('.person-group-gradient');
	const scaner = scheme.querySelector('.scaner-gradient');
	const grid = scheme.querySelectorAll('.grid-section');
	const gridColor = scheme.querySelectorAll('.grid-gradient');

	hideElement([persone, scaner]);

	hideElement([grid, gridColor]);

	vibrationSensor.forEach((el) => {
		const vibrationCircle = el.querySelectorAll('.vibration-sensor-circle');
		const vibrationFigure = el.querySelectorAll('.vibration-sensor-figure');
		const rect = el.querySelectorAll('.vibration-sensor-figure--rect--fill');
		const figureStroke = el.querySelectorAll('.vibration-sensor-figure--stroke');

		if (vibrationFigure.length) {
			if (rect.length) {
				tm.set(rect, {
					autoAlpha: 0,
				});
			}

			tm.set(vibrationFigure, {
				scaleX: 0,
				scaleY: 0,
				x: 100,
				y: 100,
			});
		}

		figureStroke.forEach((element) => {
			setStrokeDashoffset(element);
		});

		vibrationFigure.forEach((element) => {
			const vibrationSensorCircle = element.querySelector('.vibration-sensor-figure-circle');
			setStrokeDashoffset(vibrationSensorCircle);
			tm
				.set(vibrationSensorCircle, {
					stroke: '#418FDF',
				});
		});

		vibrationCircle.forEach((element) => {
			setStrokeDashoffset(element);
			tm
				.set(element, {
					stroke: '#418FDF',
				});
		});
	});

	highlightGropup.forEach((element) => {
		const highlight = element.querySelector('.highlight-default');
		const highlightGradient = element.querySelector('.highlight-gradient');

		hideElement([highlight, highlightGradient]);
	});

	lines.forEach((element) => {
		const defaultLine = element.querySelector('.lines-gradient');
		if (defaultLine) {
			hideElement(defaultLine);
		}
	});

	setStrokeDashoffset(lineDottedMask);
};

const lineAnimate = () => {
	const lines = scheme.querySelectorAll('.lines-group .lines');

	lines.forEach((element) => {
		const defaultLine = element.querySelector('.lines-gradient');
		if (defaultLine) {
			showElement(defaultLine);
		}
	});
};

const vibrationSensorAnimate = () => {
	const color = '#E0A672';
	const parent = scheme.querySelectorAll('.vibration-sensor');
	const persone = scheme.querySelector('.person-group-gradient');
	const highlight3 = scheme.querySelector('.highlight-group-3 .highlight-gradient');

	const grid = scheme.querySelectorAll('.grid-gradient');
	const scaner = scheme.querySelector('.scaner-gradient');

	const highlight1 = scheme.querySelector('.highlight-group-1 .highlight-gradient');
	const highlight2 = scheme.querySelector('.highlight-group-2 .highlight-gradient');
	const figure = scheme.querySelector('.vibration-sensor-figure--rect--fill');

	showElement([persone, highlight3], 0.45, 'startVibrationSensor+=0.75');

	showElement([grid, scaner, highlight1, highlight2, figure], 0.45, 'startVibrationSensor+=1');

	parent.forEach((element, i) => {
		const tm = gsap.timeline();
		const start = `startVibrationSensor+=${i / 2}`;
		fullAnimation.add(tm.play(), start);
		const line = element.querySelectorAll('.vibration-sensor-circle');
		const vibrationSensor = element.querySelector('.vibration-sensor-figure');
		const vibrationSensorCircle = element.querySelector('.vibration-sensor-figure-circle');
		const figureStroke = element.querySelectorAll('.vibration-sensor-figure--stroke');
		const lineDotted = scheme.querySelector('.line-dotted');
		const time = 0.75;

		if (line.length) {
			tm
				.to(line, {
					ease: Power0.easeInOut,
					strokeDashoffset: 0,
					duration: time,
				})
				.to(line, {
					ease: Power0.easeInOut,
					duration: time,
					stroke: color,
				}, time / 2);
		}

		if (figureStroke.length) {
			tm
				.to(figureStroke, {
					ease: Power0.easeInOut,
					strokeDashoffset: 0,
					duration: time,
					stagger: 0,
				}, 0)
				.to(figureStroke, {
					ease: Power0.easeInOut,
					stroke: color,
					duration: time,
					stagger: 0,
				}, time / 2);
		}

		tm
			.to(vibrationSensor, {
				scaleX: 1,
				scaleY: 1,
				x: 0,
				y: 0,
				duration: time,
			}, 0)
			.to(vibrationSensorCircle, {
				ease: Power0.easeInOut,
				strokeDashoffset: 0,
				duration: time,
			}, 0)
			.to(vibrationSensorCircle, {
				ease: Power0.easeInOut,
				stroke: color,
				duration: time,
			}, time / 2)
			.to(lineDotted, {
				ease: Power0.easeInOut,
				stroke: getFill(lineDotted),
				duration: 0.45,
				stagger: 0,
				onComplete: () => {
					lineAnimate();
				},
			}, time / 2);
	});
};
const gridAnimation = () => {
	const highlight1 = scheme.querySelector('.highlight-group-1 .highlight-default');
	const highlight2 = scheme.querySelector('.highlight-group-2 .highlight-default');
	const gridFirst = scheme.querySelectorAll('.grid-section-first');
	const gridSecond = scheme.querySelectorAll('.grid-section-second');
	const time = 0.3;
	const tm = gsap.timeline();
	fullAnimation.add(tm.play(), 'startGridAnimation');
	tm
		.to(gridFirst, {
			ease: Power0.linear,
			autoAlpha: 1,
			duration: time,
			repeat: -1,
			yoyo: true,
		}, 0)
		.to(gridSecond, {
			ease: Power0.linear,
			autoAlpha: 1,
			duration: time,
			repeat: -1,
			yoyo: true,
		}, time / 2)
		.addLabel('startVibrationSensor', time);
	showElement(highlight1, time, 'startGridAnimation+=0.2');
	showElement(highlight2, time, 'startGridAnimation+=0.2');
};

const lineDotteAnimate = () => {
	const lineDotted = scheme.querySelector('.line-dotted');
	const lineDottedMask = scheme.querySelector('.line-dotted-mask');
	const time = 1;
	const tm = gsap.timeline();
	fullAnimation.add(tm.play(), 0).addLabel('startGridAnimation', time);
	tm
		.to(lineDottedMask, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		})
		.to(lineDotted, {
			duration: 30,
			strokeDashoffset: 488,
			ease: 'none',
			repeat: -1,
		});
};

const create = () => {
	scheme = document.querySelector('.chapter-fixed__figure.scheme-6 svg');
	fullAnimation = gsap.timeline({paused: true});

	const highlight3 = scheme.querySelector('.highlight-group-3 .highlight-default');

	showElement(highlight3);
	lineDotteAnimate();
	gridAnimation();
	vibrationSensorAnimate();
};

const init = () => {
	reset();
	create();
};

export default {
	init,
	reset,
	play,
	pause,
};
